import React from "react";
import "./Chooseus.css";
import cloudimg from "../../Assets/Designs/cloudx2.png"

const chooseUsData = [
  {
    id: 1,
    title: "British Early Years Curriculum",
    description:
      "We follow the British Early Years Foundation Stage (EYFS) framework to ensure structured and age-appropriate learning.",
  },
  {
    id: 2,
    title: "Qualified & Experienced Teachers",
    description:
      "Our educators are certified professionals with years of experience in early childhood education.",
  },
  {
    id: 3,
    title: "Small Class Sizes",
    description:
      "We maintain small class sizes to ensure better engagement and focused learning for every child.",
  },
  {
    id: 4,
    title: "Individual Attention",
    description:
      "Each child receives personalized attention to support their academic and emotional development.",
  },
  {
    id: 5,
    title: "Safe & Monitored Campus",
    description:
      "Our campus is fully secured and monitored to provide a safe and nurturing environment.",
  },
];

const Chooseus = ({data}) => {
  return (
    <section className="Chooseus">
      <p className="chooseus-subtitle">{data?.chooseSubTitle}</p>
      <h2 className="chooseus-title">{data?.chooseTitle}</h2>

      <div className="Chooseus-box">
        {data?.chooseusItems?.map((item, index) => (
          <div className="Chooseus-card" key={item._id}>
            <div className="chooseus-card-left">
              <h3>{String(index + 1).padStart(2, "0")}</h3>
            </div>
            <div className="chooseus-card-right">
              <h5>{item.title}</h5>
              <p>{item.desscription}</p>
            </div>
            <img src={cloudimg} alt="" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Chooseus;